import { useQuery, UseQueryResult } from '@tanstack/react-query'
import service from './services'

export const useSiteInformation = (
): UseQueryResult<any, unknown> => {
  return useQuery({
    queryKey: ['FETCH-SITE-INFO-DETAILS'],
    queryFn: () => service.siteInformation(),
  })
}
